import { render, staticRenderFns } from "./QuestionForm2.vue?vue&type=template&id=4f8f28f8&scoped=true&"
import script from "./QuestionForm2.vue?vue&type=script&lang=js&"
export * from "./QuestionForm2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8f28f8",
  null
  
)

export default component.exports